import React from 'react';
import PropTypes from 'prop-types';

import t from '../../../lib/I18n';
import config from '../../../config';

import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';

function RewardPointsInstruction({ rewardPointUid, listClassName }) {
    return (
        <React.Fragment>
            <p>
                {t('rewardPoints.instruction.list.heading')}
                <ol className={listClassName}>
                    <li>
                        <FormattedHTMLMessage
                            message="rewardPoints.instruction.list.firstStep"
                            rewardPointsUrl={
                                <a
                                    target="_blank"
                                    className="btn btn-plain reward-points__link"
                                    href={config.get('rewardPointsUrl')}
                                >
                                    {t('rewardPoints.instruction.list.firstStep.url')}
                                </a>
                            }
                        />
                    </li>
                    <li>{t('rewardPoints.instruction.list.secondStep')}</li>
                    <li>
                        <FormattedHTMLMessage
                            message="rewardPoints.instruction.list.thirdStep"
                            rewardPointUid={<span className="reward-code">{rewardPointUid}</span>}
                        />
                    </li>
                    <li>{t('rewardPoints.instruction.list.fourthStep')}</li>
                </ol>
            </p>
            <p className="reward-points__reminder">{t('rewardPoints.instruction.reminder')}</p>
            <p>
                <FormattedHTMLMessage
                    message="rewardPoints.instruction.tsAndCs"
                    rewardPointsTermsUrl={
                        <a
                            target="_blank"
                            className="btn btn-plain reward-points__link"
                            href={config.get('rewardPointsTermsUrl')}
                        >
                            {t('rewardPoints.instruction.tsAndCs.url')}
                        </a>
                    }
                />
            </p>
        </React.Fragment>
    );
}

RewardPointsInstruction.propTypes = {
    rewardPointUid: PropTypes.string.isRequired,
    listClassName: PropTypes.string,
};

export default RewardPointsInstruction;
